import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Input,
  Select,
  Checkbox,
  FormControl,
  FormLabel,
  useToast,
} from '@chakra-ui/react';
import { getRoles, registerUser, getUserById, updateUser } from '../api/auth';

const AddUserModal = ({ isOpen, onClose, refetch, userId }) => {
  const [email, setEmail] = useState('');
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('');
  const [description, setDescription] = useState('');
  const [isEnabled, setEnable] = useState(false);
  const [roles, setRoles] = useState([]);
  const toast = useToast();

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const roleData = await getRoles();
        setRoles(roleData);
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (userId) {
        try {
          const userData = await getUserById(userId);
          if (!userData) {
            console.warn('User not found, modal will open empty.');
            return; // Kullanıcı bulunamadıysa setState yapma
          }
          setEmail(userData.email || '');
          setUserName(userData.email || '');
          setRole(userData.role || '');
          setDescription(userData.description || '');
          setEnable(userData.enabled || false);
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      } else {
        // Eğer `userId` yoksa (yeni kullanıcı ekleme durumu), inputları temizle
        setEmail('');
        setUserName('');
        setPassword('');
        setConfirmPassword('');
        setRole('');
        setDescription('');
        setEnable(false);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleSave = async () => {
    // Email formatını kontrol eden regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      toast({
        title: 'Error',
        description: 'Please enter a valid email address.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!role) {
      toast({
        title: 'Error',
        description: 'Please select a user role.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      if (userId) {
        await updateUser({
          userId,
          email,
          userName,
          role,
          description,
          isEnabled,
        });
        toast({
          title: 'Success',
          description: 'User updated successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        if (!password || password.length < 6) {
          toast({
            title: 'Error',
            description: 'Password must be at least 6 characters long.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        if (password !== confirmPassword) {
          toast({
            title: 'Error',
            description: 'Passwords do not match.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        await registerUser({ email, password, role, description, isEnabled });
        toast({
          title: 'Success',
          description: 'User added successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }

      refetch();
      onClose();
    } catch (error) {
      console.error('Error saving user:', error);
      toast({
        title: 'Error',
        description: 'Failed to save user.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{userId ? 'Edit User' : 'Add User'}</ModalHeader>
        <ModalBody>
          <FormControl display="flex" alignItems="center" mb={3}>
            <FormLabel mb="0">Enable:</FormLabel>
            <Checkbox
              isChecked={isEnabled}
              onChange={e => setEnable(e.target.checked)}
            />
          </FormControl>

          <FormControl mb={3}>
            <FormLabel>User Email:</FormLabel>
            <Input
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter email"
            />
          </FormControl>

          {/* <FormControl mb={3}>
            <FormLabel>User Name:</FormLabel>
            <Input
              value={userName}
              onChange={e => setUserName(e.target.value)}
              placeholder="Enter username"
            />
          </FormControl> */}

          {!userId && (
            <>
              <FormControl mb={3}>
                <FormLabel>Password:</FormLabel>
                <Input
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Enter password"
                  type="password"
                />
              </FormControl>

              <FormControl mb={3}>
                <FormLabel>Confirm Password:</FormLabel>
                <Input
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Confirm password"
                  type="password"
                />
              </FormControl>
            </>
          )}

          <FormControl mb={3}>
            <FormLabel>User Group:</FormLabel>
            <Select
              placeholder="Select role"
              value={role}
              onChange={e => setRole(e.target.value)}
            >
              {roles.map(roleItem => (
                <option key={roleItem} value={roleItem}>
                  {roleItem}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl mb={3}>
            <FormLabel>Description:</FormLabel>
            <Input
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Enter description"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSave}>
            {userId ? 'Update' : 'Save'}
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddUserModal;
